export const ADD_OUTSOUCE_TRANSPORTATION_SUCCESS = "logistics/ADD_OUTSOUCE_TRANSPORTATION_SUCCESS";
export const ADD_OUTSOUCE_TRANSPORTATION_FAILURE = "logistics/ADD_OUTSOUCE_TRANSPORTATION_FAILURE";
export const ADD_TRANSPORTATION_DETAILS_SUCCESS = "logistics/ADD_TRANSPORTATION_DETAILS_SUCCESS";
export const ADD_TRANSPORTATION_DETAILS_FAILURE = "logistics/ADD_TRANSPORTATION_DETAILS_FAILURE";
export const GET_SINGLE_OUTSOURCE_DETAILS_SUCCESS = "logistics/GET_SINGLE_OUTSOURCE_DETAILS_SUCCESS";
export const GET_SINGLE_OUTSOURCE_DETAILS_FAILURE = "logistics/GET_SINGLE_OUTSOURCE_DETAILS_FAILURE";

